module.exports = __webpack_public_path__ + "img/dsc-0070.f60d3283.png";